import { useCallback, useRef } from 'react';
import styles from './useAnimation.module.css';

type AnimationType = 'shake';

interface UseAnimationParams {
    type: AnimationType;
}

export const useAnimation = <T extends HTMLElement = HTMLElement>({ type }: UseAnimationParams) => {
    const ref = useRef<T>(null);

    const triggerAnimation = useCallback(() => {
        const className = styles[type];

        const element = ref.current;

        if (!element) {
            return;
        }

        element.classList.add(className);

        const handleAnimationEnd = () => {
            element.classList.remove(className);
            element.removeEventListener('animationend', handleAnimationEnd);
        };

        element.addEventListener('animationend', handleAnimationEnd);
    }, [type]);

    return { ref, triggerAnimation };
};
